import { html, LitElement } from "lit";
import { Datetime } from "../schemas/datetime";

/**
An output component styled with Web Awesome form styles.

It expects a label.
*/
class WmDateOutput extends LitElement {
  static properties = {
    value: { reflect: true },
    label: { reflect: true },
  };

  declare readonly value: string;
  declare readonly label: string;

  constructor() {
    super();
    this.value = "";
    this.label = "";
  }

  render() {
    return html`
      <wm-output label="${this.label}" appearance="outlined">${this.value ? Datetime.formatPretty(Datetime.codec.decode(this.value)) : ""}</wm-output>
      `;
  }
}

customElements.define("wm-date-output", WmDateOutput);
